<template>
  <div>
    <b-overlay opacity="0.20" no-center :show="isShowOverlay">
      <router-view @makeToasts="makeToasts"></router-view>
    </b-overlay>
    <b-modal modal-class="conf-modal" hide-footer hide-header ref="modalConfirmation" @hidden="isShowOverlay = false">
      <h1 style="text-align: center">{{ $t(confTitle) }}</h1>
      <p style="text-align: center">{{ $t(confBody) }}</p>

      <b-row style="margin-bottom:-8px;margin-left:-16px;margin-right:-16px">
        <b-col cols="6" style="padding-left:0px;padding-right:0px;">
          <button type="button" class="cancelbtn" @click="$refs.modalConfirmation.hide()">{{ $t('Cancel') }}</button>
        </b-col>
        <b-col cols="6" style="padding-left:0px;padding-right:0px">
          <button type="button" class="deletebtn" @click="okConfirmation()">Ok</button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style>

div.conf-modal .modal-content {
  border: 0px;
  border-radius: 0px;
}

div.conf-modal .modal-content .modal-body {
  padding-bottom: 0px;

}

/* Float cancel and delete buttons and add an equal width */
.cancelbtn, .deletebtn {
  float: left;
  width: 50%;
  background-color: #4CAF50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
  opacity: 0.9;
}

.cancelbtn:hover, .deletebtn:hover {
  opacity: 0.6;
}

/* Add a color to the cancel button */
.cancelbtn {
  background-color: #ccc;
  color: black;
}

/* Add a color to the delete button */
.deletebtn {
  background-color: #D69257;
}

</style>

<script>
export default {
  data () {
    return {
      isShowOverlay: false,
      confTitle: '',
      confBody: '',
      confFunc: null,
      confData: null
    }
  },
  methods: {
    makeToasts (variant = 'success', body = this.$t('Success'), title = '') {
      this.$bvToast.toast(this.$t(body), {
        variant: variant,
        title: title,
        solid: true,
        autoHideDelay: 7000
      })
    },
    showConfirmation (title, body, func, funcData) {
      this.isShowOverlay = true
      this.confTitle = title
      this.confBody = body
      this.confFunc = func
      this.confData = funcData
      this.$refs.modalConfirmation.show()
    },
    okConfirmation () {
      this.isShowOverlay = false
      this.$refs.modalConfirmation.hide()
      this.confFunc(this.confData)
    }
  },
  mounted () {
    this.$root.$on('makeToasts', this.makeToasts)
    this.$root.$on('showConfirmation', this.showConfirmation)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/Content.vue